import React from 'react';

export const CreateGroupModal = ({ property, createGroupForm, setCreateGroupForm, onSubmit, onClose }) => (
  <div className="modal-overlay" onClick={onClose} data-testid="create-group-modal-overlay">
    <div className="modal-content" onClick={(e) => e.stopPropagation()} data-testid="create-group-modal">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
        <h2 style={{ margin: 0, color: '#1a2332' }}>Start a Group on This Property</h2>
        <button onClick={onClose} style={{ background: 'none', border: 'none', fontSize: '24px', cursor: 'pointer', color: '#6b7280' }}>&times;</button>
      </div>
      <p style={{ color: '#6b7280', marginBottom: '20px', fontSize: '14px' }}>
        This creates a group for <strong>{property?.city}, {property?.state}</strong>. You'll be the first member.
      </p>
      <form onSubmit={onSubmit}>
        <div style={{ marginBottom: '16px' }}>
          <label style={{ display: 'block', marginBottom: '6px', fontWeight: '600', fontSize: '14px' }}>Group Type</label>
          <select value={createGroupForm.group_type} onChange={(e) => setCreateGroupForm({...createGroupForm, group_type: e.target.value})}
            style={{ width: '100%', padding: '10px 12px', border: '2px solid #e5e7eb', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box' }}
            data-testid="group-type-select">
            <option value="Mixed">Mixed</option>
            <option value="SingleFemale">Single Female</option>
            <option value="SingleMale">Single Male</option>
            <option value="Couples">Couples</option>
          </select>
        </div>
        <div style={{ marginBottom: '20px' }}>
          <label style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '14px', cursor: 'pointer' }}>
            <input type="checkbox" checked={createGroupForm.is_couple} onChange={(e) => setCreateGroupForm({...createGroupForm, is_couple: e.target.checked})}
              style={{ width: '18px', height: '18px' }} data-testid="is-couple-checkbox" />
            I am joining as a couple (counts as 1 spot)
          </label>
        </div>
        <div style={{ display: 'flex', gap: '12px' }}>
          <button type="submit" className="btn btn-primary" style={{ flex: 1 }} data-testid="create-group-submit">Start Group</button>
          <button type="button" className="btn btn-secondary" onClick={onClose} style={{ flex: 1 }}>Cancel</button>
        </div>
      </form>
    </div>
  </div>
);

export const ExpressInterestModal = ({ property, interestForm, setInterestForm, onSubmit, onClose, loading }) => (
  <div className="modal-overlay" onClick={onClose} data-testid="interest-modal-overlay">
    <div className="modal-content" onClick={(e) => e.stopPropagation()} data-testid="interest-modal">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
        <h2 style={{ margin: 0, color: '#1a2332' }}>Express Interest</h2>
        <button onClick={onClose} style={{ background: 'none', border: 'none', fontSize: '24px', cursor: 'pointer', color: '#6b7280' }}>&times;</button>
      </div>
      <p style={{ color: '#6b7280', marginBottom: '20px' }}>
        Let us know you're interested in <strong>{property?.city}, {property?.state}</strong>. The admin team will be notified.
      </p>
      <form onSubmit={onSubmit}>
        <div style={{ marginBottom: '16px' }}>
          <label style={{ display: 'block', marginBottom: '6px', fontWeight: '600', fontSize: '14px' }}>Your Phone (optional)</label>
          <input type="tel" value={interestForm.phone} onChange={(e) => setInterestForm({...interestForm, phone: e.target.value})}
            placeholder="e.g. 0412 345 678"
            style={{ width: '100%', padding: '10px 12px', border: '2px solid #e5e7eb', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box' }}
            data-testid="interest-phone-input" />
        </div>
        <div style={{ marginBottom: '20px' }}>
          <label style={{ display: 'block', marginBottom: '6px', fontWeight: '600', fontSize: '14px' }}>Message (optional)</label>
          <textarea value={interestForm.message} onChange={(e) => setInterestForm({...interestForm, message: e.target.value})}
            placeholder="Tell us why you're interested..." rows={4}
            style={{ width: '100%', padding: '10px 12px', border: '2px solid #e5e7eb', borderRadius: '8px', fontSize: '14px', resize: 'vertical', boxSizing: 'border-box' }}
            data-testid="interest-message-input" />
        </div>
        <div style={{ display: 'flex', gap: '12px' }}>
          <button type="submit" className="btn btn-primary" disabled={loading} style={{ flex: 1 }} data-testid="interest-submit-btn">
            {loading ? 'Sending...' : 'Send Interest'}
          </button>
          <button type="button" className="btn btn-secondary" onClick={onClose} style={{ flex: 1 }}>Cancel</button>
        </div>
      </form>
    </div>
  </div>
);
